module.exports = require("./ff-Latn-CM");